module.exports = __webpack_public_path__ + "img/Group 248.3504375d.svg";